export default __webpack_public_path__ + "static/undraw_face_recognition-ea790297c942278a5ce070d880fa98d3.svg";